const en = {
	langPortuguese: "<img class='country-icon' src='/images/locale-flag-br.png', alt=''><span> Portuguese </span>",
	langEnglish: "<img class='country-icon' src='/images/locale-flag-en.png', alt=''><span> English </span>",
	langSpanish: "<img class='country-icon' src='/images/locale-flag-es.png', alt=''><span> Spanish </span>",
	langMandarin: "<img class='country-icon' src='/images/locale-flag-ma.svg', alt=''><span> Mandarin </span>",
	home: "Home",
	publications: "Publications",
	aboutUs: "About us",
	projects: "Presence",
	recruitingProcess: "Recruiting process",
	sendCurriculum: "Send resume",
	contactUs: "Contact us",
	toContactUs: "Contact us",
	team: "Team",
	direction: "Direction",
	administrativeCouncil: "",
	UPA: "UPA",
	UPAs: "UPAs",
	emergencyUnit: "Emergency Unit",
	emergencyUnits: "Emergency Units",
	soniprevSlogan: "The future in health management.",
	mission: "Mission",
	vision: "Vision",
	values: "Values",
	seeMore: "See more",
	seeLess: "See less",
	seeAll: "See all",
	close: "Close",
	and: "and",
	validationError: "Validation error",
	checkErrorsAndTryAgain: "Check the errors and try again.",
	services: "Services",
	solutions: "Solutions",
	name: "Name",
	company: "Company",
	message: "Message",
	phone: "Phone",
	cellphone: "Cellphone",
	location: "Location",
	zipCode: "ZIP Code",
	send: "Send",
	maleDoctorTitle: "MD.",
	femaleDoctorTitle: "MD.",
	internalMedicine: "Internal medicine",
	generalSurgery: "General surgery",
	gynecology: "Gynecology",
	obstetrics: "Obstetrics",
	medicalClinic: "Medical clinic",
	anesthesiology: "Anesthesiology",
	pediatrics: "Pediatrics",
	pediatricSurgery: "Pediatric Surgery",
	maxillofacial: "Maxillofacial",
	plasticSurgery: "Plastic Surgery",
	proctologicalSurgery: "Proctological Surgery",
	thoracicSurgery: "Thoracic Surgery",
	vascularSurgery: "Vascular Surgery",
	intensiveCareUnit: "Intensive Care Unit",
	clinicalEmergency: "Clinical Emergency",
	nursing: "Nursing",
	pharmacy: "Pharmacy",
	physiotherapy: "Physiotherapy",
	speechTherapy: "Speech Therapy",
	infectology: "Infectology",
	nephrology: "Nephrology",
	neurosurgery: "Neurosurgery",
	neurology: "Neurology",
	nutrition: "Nutrition",
	clinicalNutrition: "Clinical Nutrition",
	dentistry: "Dentistry",
	orthopedy: "Orthopedy",
	psychology: "Psychology",
	psychiatry: "Psychiatry",
	socialService: "Social Service",
	occupationalTherapy: "Occupational Therapy",
	postoperativeCare: "Postoperative Care",
	urology: "Urology",
	homePage: {
		slider: {
			beAPartOfTheTeam: "Signup and be a part of our team!",
			weHaveTheBestJobs: "We have the bets jobs at hand! Do it now, it is fast and simple!",
			wantToSignup: "I want to signup",
			biggestHealthCompany: "Brazil's biggest Health management company.",
			contactUsAndWeWillAnswer: "Contact us and we will answer as soon as possible.",
		},
		publications: {
			description: "On this page we post publications, reports of public and medical interests, company's standard resumes etc.",
			CovidSymposium: "Brazilian Symposium on COVID19 (online)",
			corona: "Coronavirus",
			getulioVargasHospital: "Getúlio Vargas State Hospital",
			jobs: "Jobs",
			checkOpenJobs: "Check the available jobs",
			openEnrollment: "Enrollment open",
			openClassEnrollment: "The enrollment for %{class} class is open",
		},
		aboutUs: {
			about: "About",
			theCompany: "the company",
			soniprevProfessionals: "Soniprev captures professionals from different health areas to work in the most diverse hospital segments. They are all trained professionals, focusing on humanized and resolving care. We are specialists in offering medical service management solutions, according to the needs of your project and without putting health in the background.",
			soniprevPartnership: "Today we work through partnerships with private and philanthropic entities in the management of health units, we are committed to the optimization of public-private resources and unique responsibility with each project.",
		},
		cardSection: {
			soniprevMission: "Make health, taking humanized care to the patient and participating in projects of excellence with honesty and transparency.",
			soniprevVision: "Become a national reference in management and solutions for hospital care units.",
			honestyAndEthics: "Honesty and Ethic",
			efficiencyAndCommitment: "Efficiency and Commitment",
			credibilityAndRespect: "Credibility and Respect for Human Beings",
			responsibility: "Social and Environmental Responsibility",
		},
		team: {
			positionOne: {
			},
			positionTwo: {
				sector: "Direction",
				name: "Luiz Becker",
				office: "CEO - Chief Executive Officer",
				graduationSummary: "Luiz Carlos Becker Jr. holds a Master's (MSc) in Business Administration from Unigranrio, a Postgraduate Degree in Public Policy and Government from the School of Government at UFRJ, a Bachelor of Law and Executive Education from...",
				graduation: "Luiz Carlos Becker Jr. holds a Master's (MSc) in Business Administration from Unigranrio, a Postgraduate Degree in Public Policy and Government from the School of Government at UFRJ, a Bachelor of Law and Executive Education from Universidade Estácio de Sá. He is CEO - Chief Executive Officer - of  <span style='color: #0c4da2'>SONIPREV</span>. He worked in private, public, federal and state organizations, exercising several executive management functions, among them the Under Secretary of State for Education of the State of Rio de Janeiro, Manager of Administration and Human Resources of the State of Rio de Janeiro at Caixa Econômica Federal, Chief Division of Labor Relations, Operational Manager of the Branch Network and Coordinator of the CEF Quality Office, among others. President of the State Education Forum of the State of Rio de Janeiro from 2011 to Apr / 2014. Consultant to OEI - Organization of Ibero-American States for Education, Science and Culture. Technical Consultant of MEC / INEP from Jan to Apr / 2019. He was responsible for coordinating the operational strategies of the Bolsa Escola Federal and Bolsa Comida Minimum Income Programs. Awarded at the III Contest of Innovative Experiences in the Federal Public Administration - Hélio Beltrão Award - ENAP / 1998. He has extensive experience in conducting and developing the strategic planning of several institutions. He has been a Business Consultant, Speaker, Writer and Professor for more than 20 years in several Postgraduate and MBA courses at Fundação Getulio Vargas and Unipê / PB in the disciplines of Strategic Planning, Quality and Process Management, Leadership and People Management, Team Development, Project Quality Management and Project Resource Management. Co-author of the books - Team Development and Strategic Planning and Management in Health Organizations, both by the FGV publisher.",
			},
			positionTree: {
				sector: "Direction",
				name: "MD. Filipe Magnani",
				office: "Medical Director",
				graduationSummary: "Officially trained in the Brazilian Army in 2006, he dedicated himself to completing the Medicine course in 2013. He worked in all segments of the SUS, such as Family Clinics, Emergency Care Units and large Hospitals, worked also...",
				graduation: "Officially trained in the Brazilian Army in 2006, he dedicated himself to completing the Medicine course in 2013. He worked in all segments of the SUS, such as Family Clinics, Emergency Care Units and large Hospitals, worked also in private monitoring in large Hospitals. Inserted 05 (five) years ago in the market as a Medical Manager, he was in charge of outpatient clinics and clinical services as coordinator, served as Medical Manager of a private network of Hospitals and Clinics, coordinator of UPA's 24 hours and today serves as Medical Director of Company  <span style='color: #0c4da2'>SONIPREV</span>. Post-graduated in Endocrinology and Metabology, certified by the school of public administration in 2020 in the areas of risk management in the public sector, pounds, personal management based on leadership and introduction to process management and was certified by ONA - National Organization of Accreditation, in the Brazilian System of Accreditation for Assessors - 2017. Currently, he has completed the course of the Syrian-Lebanese Institute of Teaching and Research in Influenza Syndrome and COVID-19 and the course of the Oswaldo Cruz Foundation in COVID-19 - Management of Infection Caused by New Coronavirus.",
			},
			positionFour: {
				sector: "Administrative Council",
				name: "MD. André Vieira",
				office: "Counselor",
				graduationSummary: "Bachelor of Medicine from the Faculty of Medicine of Teresópolis (1998). He completed the Hospital Internship Program at the Hospital de la Fuerza Aérea de Galeão...",
				graduation: "Bachelor of Medicine from the Faculty of Medicine of Teresópolis (1998). He completed the Hospital Internship Program at the Hospital de la Fuerza Aérea de Galeão-HFAG-RJ in 1998. He holds a Medical Diploma certification from the Universidade Federal Fluminense-UFF-RJ (1998). Specialization in General Surgery at Hospital Municipal Miguel Couto - RJ (2005). Certified member of the Brazilian College of Surgeons / Núcleo Central - RJ (2005). Full member of the American Academy of Aesthetic Surgery-AACS-USA- (2008). And managing partner of  <span style='color: #0c4da2'>SONIPREV</span>.",
			},
			positionFive: {
				sector: "Administrative Council",
				name: "MD. Hilda Freitas",
				office: "Counselor",
				graduationSummary: "Graduated in Medicine in 1997 from the State University of Pará. Qualified in Colposcopy by CETRUS (Ultrasonography Training Center of São Paulo-SP). Training and qualification in Ultrasonography by the Fetal Medicine Foundation - London. Member of the Pará Association of...",
				graduation: "Graduated in Medicine in 1997 from the State University of Pará. Qualified in Colposcopy by CETRUS (Ultrasonography Training Center of São Paulo-SP). Training and qualification in Ultrasonography by the Fetal Medicine Foundation - London. Member of the Pará Association of Gynecology and Obstetrics. Member of the Brazilian Association of Genitoscopy-Pará Chapter. Empretec Belém Workshop in 2008; Basic Fundamentals of Good Management Course in 2009. Executive MBA in Health from Fundação Getúlio Vargas - FGV / Rio de Janeiro (in progress). And Managing Partner of  <span style='color: #0c4da2'>SONIPREV</span>.",
			},
			positionSix: {
				sector: "Administrative Council",
				name: "MD. Marcus Vinicius Rodrigues",
				office: "Managing Partner",
				graduationSummary: "PhD in Production Engineering from Coppe / UFRJ, Master (MSc) in Business Administration from Cepead / UFMG, Specialist with a Specialization Course...",
				graduation: "PhD in Production Engineering from Coppe / UFRJ, Master (MSc) in Business Administration from Cepead / UFMG, Specialist with a Specialization Course (MBA) in Executive Training from Esap / DF and is an Electrical Engineer from EE / UFC. He is an Executive, Writer, Organizational Consultant and Professor. He is an effective and lifelong member of the Brazilian Academy of Management Sciences. He was President of Inep / MEC; he was Executive Manager of Nucap / FGV; he was a Post Office Executive; he was a Researcher and Professor at Ebap / FGV. He is a Senior Consultant at FGV Projetos; he is Director of the Learning Center and Organizational Solutions (CASO Consultores Associados); he is Director of the Management Magazine of Portuguese Speaking Countries (B1 / Qualis / Capes); is a Board Member and Institutional Advisor at  <span style='color: #0c4da2'>SONIPREV</span>. Since 1996 until today, professor and Academic Coordinator of the MBA’s at FGV. He joined the permanent staff at FGV with the status of Adjunct Professor at EBAPE - Brazilian School of Public and Business Administration at FGV in 2004, where he stayed until November 2018. He was Visiting Professor at ISCTE - Instituto Universitário in Lisbon. Today, in addition to FGV's MBA's, he serves as a Visiting Professor in several doctoral, master's and MBA programs in management at Brazilian, Portuguese, Mozambican and Angolan institutions. As a writer, he is the Author of dozens of technical articles published in specialized magazines and the Author or Coauthor of twelve books, ten of them on management, quality and productivity.",
			},
			positionSeven: {
				sector: "Administrative Council",
				name: "Wilson Risolia Rodrigues",
				office: "Counselor",
				graduationSummary: "Graduated in Economic Sciences, Post-graduated in Economic Engineering with Extension in Economic Development - ISVE (Italy) and MBA in Finance  and Capital Markets...",
				graduation: "Graduated in Economic Sciences, Post-graduated in Economic Engineering with Extension in Economic Development - ISVE (Italy) and MBA in Finance and Capital Markets - IBMEC. He is the Secretary General of the Roberto Marinho Foundation. He was CEO of Falconi Consultores de Resultados and CFO of the Organizing Committee of the Olympic Games - Rio 2016. He held the position of Secretary of State for Education of the State of Rio de Janeiro from 2010 to 2014. He was President of RioPrevidência from 2007 to 2010. Vice- President of Caixa Econômica Federal (Asset Manager). He is a member of the Brazilian Academy of Education. Recognized as Educator of the Year in 2012 by Academia and Revista Época as one of the 100 personalities of the year. In 2015, it was recognized by the IDB for the implementation of the Educational Diagnostic Assessment System in RJ. The work carried out in education in Rio de Janeiro also deserved citations / articles by professionals from the World Bank (economist Barbara Brun) and MIT (Professor Ben Schneider).",
			},
			positionNine: {
				sector: "Administrative Council",
				name: "Helena Ribeiro",
				office: "Administrative Council",
				graduationSummary: "Helena Ribeiro is a Founding Partner of the EMPZ Group and the ESUP College, Counselor of Winning Women EY Brazil. The EMPZ Group is specialized in Outsourcing...",
				graduation: "Helena Ribeiro is a Founding Partner of the EMPZ Group and the ESUP College, Counselor of Winning Women EY Brazil. The EMPZ Group is specialized in Outsourcing of HR Business Services and Executive Education through ESUP FGV College in Goiás, with more than 30 years in the market. In 2016, she was ranked 25th among the 100 most influential women in the world by the Global Power 100 Women in Staffing. She was awarded as a Master Entrepreneur 2012 by EY, chaired the BA of Amcham, Lide Mulher, GMdB, as well as VP ACIEG and the Board of CODESE. Member of Open Mind Brazil and IUB.",
			},
			positionTen: {
				sector: "Direction",
				name: "Luis Vivanco",
				office: "Executive Director",
				graduationSummary: "Prof. Luis Vivanco holds a Master's in Economics from IBMEC Business School and he is concluding PhD in Economics from the Getúlio Vargas Foundation. He is a specialist in Financial Management, Controllership, Accounting and Auditing and has been teaching...",
				graduation: "Prof. Luis Vivanco holds a Master's in Economics from IBMEC Business School and he is concluding PhD in Economics from the Getúlio Vargas Foundation. He is a specialist in Financial Management, Controllership, Accounting and Auditing and has been teaching subjects in the most renowned educational institutions in the country and abroad for 18 years. Worked as a Senior Economist at the Presidency of Brazil’s Mint and as a member of the Strategic Studies Center, in addition to acting as a consultant for the following companies: BANESE, Itáu, Segmedic, Petrobrás and Vale. He holds a CPA-20 certification and is the author of the following works by Editora Ferreira: Economia para Concursos, Questões de Economia and Estatística Simplificada, as well as numerous economic articles published in Brazilian Business Review, BBC London, Conjuntura Econômica- FGV and Revista Foco. He was recently appointed by the Ministry of Economy as Board Member of Brazil’s Mint and worked as a Senior Economist at Travelex Bank.",
			},
		},
		services: {
			teamManagement: "Multidisciplinary Team Management",
			administrativeManagement: "Administrative management of resources in Public and Private Units",
			healthUnitsProjects: "Formulation of Projects for the implantation of Health Units",
			assistProtocols: "Formulation of assistance protocols",
			healthUnitDiagnosis: "Technical and administrative diagnosis of Health Units",
			hospitalCertification: "Adequacy of the Health Unit for Hospital Accreditation Certification, among others",
		},
		areas: {
			expertiseAreas: "Solutions",
		},
		projects: {
			clickOnTheMap: "Click on a location on the map to learn more about the projects carried out and in progress in each state",
			done: "Contracts Closed",
			inProgress: "Current Contracts",
		},
		selective: {
			processDescription: "Soniprev, in the use of its attributions, makes public the opening of registrations for the permanent selection process, hereinafter called PSP, aimed at selecting and forming a reserve signup for positions in various specialties in the health area. Signup today and be part of this select group of professionals, so you will be guaranteeing your access to the exclusive Soniprev application, where we provide personalized on-call schedules for the professional's private use.",
		},
		feedback: {
			namePlaceholder: "Enter your name",
			companyPlaceholder: "Enter your current company",
			emailPlaceholder: "Enter your e-mail",
			phonePlaceholder: "Enter your phone",
			messagePlaceholder: "Enter your message",
		},
	},

	publication: {
		information: {
			publi_1: {
				congratulationsSoniprevTeam: "Congratulations to the entire Soniprev team!",
				description_1: "Another year to celebrate!",
				description_2: "Another year to celebrate,",
				description_3: "another year to write new success stories.",
			},
			publi_2: {
				CovidSymposium: "Brazilian Symposium on COVID19 (online)",
				description_1: "Date: May 26",
				description_2: "Hours: 18 to 22 hours",
				description_3: "Meeting of great experts, exchanging their knowledge and experiences for professionals from all over Brazil.",
				description_4: "Don't miss it!",
				description_5: "The registration is ending soon.",
			},
			publi_3: {
				corona: "Announcement",
				description_1: "Through this communiqué, Soniprev highlights the population of the great importance of following the guidelines given by the Secretary of Health and by all professionals in the medical field.",
				description_2: "We advise maintaining hand hygiene measures frequently, avoiding crowding, always seeking official information and keeping away from doubtful information. Do not seek emergency care if you have mild symptoms, as this may increase the demand for the spread of infectious diseases, if you experience shortness of breath and pain \"in the chest\" when breathing please look for the nearest health unit.",
				description_3: "Soniprev also takes the opportunity to thank all health professionals who are on the front line fighting this important pandemic, our thanks and count on us in this fight.",
			},
			publi_4: {
				description_1: "The Emergency Care Units (UPA 24h) are health facilities of intermediate complexity, articulated with Primary Care, the Mobile Emergency Care Service - SAMU 192, Home Care and Hospital Care, which favor the effective and efficient functioning of the Emergency Care Network (RAU).",
				description_2: "These units provide service around the clock, from Monday to Sunday, aiming to welcome and serve all users who seek assistance, uninterruptedly.",
			},
			publi_5: {
				getulioVargasHospital: "Getúlio Vargas State Hospital",
			},
			publi_6: {
				jobsSoniprev: "Soniprev jobs",
				description_1: "Join our team of more than 800 doctors. We have permanent vacancies in the following sectors:",
				description_2: "If you are interested in joining our team, sign up for our",
				description_3: "selective process.",
			},
			publi_7: {
				videoSoniprev: "Soniprev Video",
			},
		},
	},

	pageNotFound: {
		title: "Page not found",
		message: "",
	},
	routes: {
		edit: "edit",
		signup: "signup",
		publication: "publication",
		publications: "publications",
		aboutUs: "about-us",
		projects: "projects",
		contactUs: "contact-us",
	},
	signUpPage: {
		notAvailableTitle: "Not available",
		notAvailableMessage: "Recruiting is currently available only to Brazilian citizens.",
	},

};

export default en;
